import React, { Component } from 'react';
import { MobileApps } from './MobileApps'
import { QATools } from './QATools'
import { WebWritings } from './WebWritings'

import '../css/fonts.css';
import '../css/addlightness.css';

export class BoxenRow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showApps: false,
      animating: false,
      animTriggered: false,
      animPct: 1.0,
    }

    this.ANIM_DECREMENT = 0.2

    this.renderCenterBox = this.renderCenterBox.bind(this)
    this.getClassByAnimationState = this.getClassByAnimationState.bind(this)
    this.startAnimation = this.startAnimation.bind(this)
    this.stopAnimation = this.stopAnimation.bind(this)

    this.blurFunc = this.blurFunc.bind(this)
  }

  blurFunc() {
    console.log("BottomFold blurFunc()")
  }

  unBlurFunc() {
    console.log("BottomFold unBlurFunc()")
  }

  startAnimation() {
    this.setState({
      animationStartTime: Date.now(),
      animating: true,
      animTriggered: true,
    })

    setInterval(() => {
      if ( this.state.animPct <= 0 ) {
        this.setState({ animating: false })
      } else {
        const newPct = this.state.animPct - this.ANIM_DECREMENT
        this.setState({
          animPct: newPct })
      }
    }, 20)
  }


  stopAnimation() {
    this.setState({
      animationStartTime: null,
      animating: false,
      showApps: false,
    })
  }


  renderCenterBox() {

    const beforeText = 'Before Animation'
    const afterText = 'after'
    const innerText = this.state.animTriggered ? afterText : beforeText

    const normalFontSize = 34
    const largeFontSize = 60
    const maxDiff = largeFontSize - normalFontSize
    var fontSize

    if ( ! this.state.animTriggered ) {
      fontSize = normalFontSize
    } else {
      const currentDiffSize = maxDiff * ( 1 - this.state.animPct )
      fontSize = normalFontSize + currentDiffSize
    }

    const centerBoxStyle = {
      display: "flex",
      flexDirection: "column",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      background: "#ffffff",
      border: "2px solid #443321",
      padding: "10px",
      paddingTop: "15px",
      fontFamily: "BeyondInfinity",
      fontSize: `${fontSize}px`,
      marginLeft: "5px",
      marginRight: "5px",
      marginTop: "-20px",
    }


    return (
        <div style={centerBoxStyle}>
          <div className="mobile-apps-element"
          >
            { innerText }
          </div>
        </div>
      )
    }


  renderAppDescriptionBox() {
    const descriptions = {
      'futbol' : `
        Mobile App UI for soccer statistics and historical data
      `,
      'camper' : `
        Easy registration + check-in for youth camping trips.
      `,
      'auth0' : `
        Some boilerplate for integrating Auth0 with a React Native app.
        Integrates Router and Redux based navigation.
      `,
    }

    const appNames = {
      'camper': 'Happy Camper',
      'futbol': 'Futbol Data Client',
      'auth0': 'Auth0 Template'
    }

    return (
      <div className="app-description-box">
        <h4>{ appNames[ this.state.whichAppHovered] }</h4>
        { descriptions[this.state.whichAppHovered] }
      </div>
    )
  }


  getClassByAnimationState(elementRef) {
    if ( elementRef === "add-lightness" ) {
      const alClassName = this.state.showApps? "add-lightness-blurred" : "add-lightness"
      return alClassName
    }
    if ( elementRef === "mobile-apps-expanded" ) {
      return "mobile-apps-expanded"
    }
  }


  render() {

    //const alClassName = this.getClassByAnimationState('add-lightness')

    /*
    const headerOpacity = this.state.animPct
    const shadowPxMax = 12
    const shadowPx = shadowPxMax * ( 1 - this.state.animPct )

    const headerStyle = {
      fontFamily: 'BeyondInfinity',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: 'normal',
      //textShadow: '0 0 12px #1F557D',
      textShadow: `0 0 ${shadowPx}px #1F557D`,
      fontSize: '138px',
      color: `rgba(31, 85, 125, ${headerOpacity})`
    }
    */

    const boxBlurredStyle = {
      display: "inline-block",
      position: "relative",
      zIndex: 1,
      marginLeft: "5px",
      marginRight: "5px",
      boxSizing: "border-box",
      padding: "10px",
      paddingTop: "15px",
      background: "rgba(255, 255, 255, 0.5)",
      fontFamily: "BeyondInfinity",
      fontSize: "34px",
      cursor: "pointer",
      color: "transparent",
      textShadow: "0 0 10px #1F557D",
    }

    const boxUnblurredStyle = {
      border: "2px solid #000000",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      background: "#ffffff",
      display: "inline-block",
      position: "relative",
      zIndex: 1,
      marginLeft: "5px",
      marginRight: "5px",
      boxSizing: "border-box",
      padding: "10px",
      paddingTop: "15px",
      fontFamily: "BeyondInfinity",
      fontSize: "34px",
      cursor: "pointer",
    }

    const anchorBlurredStyle = {
      textShadow: `0 0 ${this.state.anchorBlurShadowPx}px #1F557D`,
      //color: "transparent",
    }


    return (
        <div id="bottom-half">

          {/*
          <div id="bottom-grid-container">
            <div>
              <div id="box1-bottom" class="bottom-box">
                foo
              </div>
              <div id="box2-bottom" class="bottom-box">
                bar
              </div>
              <div id="box3-bottom" class="bottom-box">
                baz
              </div>
            </div>

            <div>
              <div id="box4-bottom" class="bottom-box">
                qux
              </div>
              <div id="box5-bottom" class="bottom-box">
                ish
              </div>
              <div id="box6-bottom" class="bottom-box">
                mel
              </div>
            </div>

            <div>
              <div id="box7-bottom" class="bottom-box">
                biv
              </div>
              <div id="box8-bottom" class="bottom-box">
                bng
              </div>
              <div id="box9-bottom" class="bottom-box">
                bim
              </div>
            </div>
          </div>
          */}

         <div className="boxen-row">
            <div>
              <MobileApps
                blurredStyle={boxBlurredStyle}
                unBlurredStyle={boxUnblurredStyle}
                whichBoxWasTriggered={this.state.whichBoxWasTriggered}
                blurFunc={this.blurFunc}
                unBlurFunc={this.unBlurFunc}
              />
            </div>
            <div>
              <QATools
                blurredStyle={boxBlurredStyle}
                unBlurredStyle={boxUnblurredStyle}
                whichBoxWasTriggered={this.state.whichBoxWasTriggered}
                blurFunc={this.blurFunc}
                unBlurFunc={this.unBlurFunc}
              />
            </div>
            <div>
              <WebWritings
                blurredStyle={boxBlurredStyle}
                unBlurredStyle={boxUnblurredStyle}
                anchorBlurredStyle={anchorBlurredStyle}
                whichBoxWasTriggered={this.state.whichBoxWasTriggered}
                blurFunc={this.blurFunc}
                unBlurFunc={this.unBlurFunc}
              />
            </div>
          </div>
      </div>
    )
  }
}
